import { IRootState } from '../../../../store'
import { IExtricationState } from '../store/extrication.types'

export const getExtricationSelector = (state: IRootState): IExtricationState => state.extrication
